import { render, staticRenderFns } from "./PayMerchantList.vue?vue&type=template&id=31b055a2&scoped=true"
import script from "./PayMerchantList.vue?vue&type=script&lang=js"
export * from "./PayMerchantList.vue?vue&type=script&lang=js"
import style0 from "./PayMerchantList.vue?vue&type=style&index=0&id=31b055a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b055a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b055a2')) {
      api.createRecord('31b055a2', component.options)
    } else {
      api.reload('31b055a2', component.options)
    }
    module.hot.accept("./PayMerchantList.vue?vue&type=template&id=31b055a2&scoped=true", function () {
      api.rerender('31b055a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/paymerchant/PayMerchantList.vue"
export default component.exports